import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
	const slider = document.querySelector(
		'.js-pdp-bundle-slider'
	) as HTMLElement

	if (!slider) return

	new Swiper(slider, {
		modules: [Pagination, Navigation],
		slidesPerView: 1.39,
		navigation: {
			prevEl: slider.querySelector(
				'.swiper-button-prev'
			) as HTMLButtonElement,
			nextEl: slider.querySelector(
				'.swiper-button-next'
			) as HTMLButtonElement,
		},
		pagination: {
			el: slider.querySelector('.swiper-pagination') as HTMLElement,
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
		},
	})
})
